export const URL_BUSINESS_HUB = '/businessHub'
export const URL_TWO_STAGED_OFFERS_HUB = '/twoStagedOffersHub'
export const URL_AUCTION_HUB = '/auctionHub'
export const URL_REQUEST_OFFERS_HUB = '/requestOffersHub'
export const URL_REQUEST_OFFERS_DIVISIBLE_VOLUME_HUB = '/requestOffersDivisibleVolumeHub'

export const SIGNALR_TEST_GROUP = 'signalRTestGroup'

export const SIGNALR_MIXIN_PARAMS = {
  GET_HUB_METHOD_NAME: 'getHubMethodName',
  EVENTS_LIST: 'eventsList',
  EVENT_NAME: 'eventName',
  CALLBACK_NAME: 'callbackName',
  INVOKE_LIST: 'invokeList',
  METHOD_NAME: 'methodName',
  GET_GROUP_NAME_METHOD: 'getGroupNameMethod',
  RECONNECT_CALLBACK_NAME: 'reconnectCallbackName'
}

export const SIGNALR_EVENT_NAMES = {
  ADD_NEW_ORDER: 'addNewOrder',
  UPDATE_ORDERS: 'updateOrders',
  SESSION_LOCK_STATUS_CHANGED: 'sessionLockStatusChanged',
  CATCH_NEW_MESSAGE: 'catchNewMessage'
}

export const SIGNALR_INVOKE_NAMES = {
  ADD_TO_GROUP: 'addToGroup',
  ADD_TO_TEST_GROUP: 'addToTestGroup',
  SEND_TEST_MESSAGE: 'sendTestMessage'
}

export const SIGNALR_CALLBACK_NAMES = {
  ADD_NEW_ORDER: 'addNewOrder',
  UPDATE_ORDERS: 'updateOrders',
  SESSION_LOCK_STATUS_CHANGED: 'sessionLockStatusChanged',
  GET_SIGNALR_GROUP_NAME: 'getSignalRGroupName',
  CATCH_NEW_MESSAGE: 'catchNewMessage',
  GET_HUB_NAME: 'getHubName'
}
